// TODO use enums for this throughout the application
export enum RemovalCode {
  Systematic = '030. Systematisk',
  Other = '090. Andet',
  Euthanized = '155. Aflivet',
  Dead = '190. Død',
}

export enum RemovalReason {
  RespiratoryDisease = '200. Luftvejslidelser',
  DigestiveDisorder = '300. Fordøjelsesforstyrrelse',
  StomachUlcer = '360. Mavesår',
  IntestinalProlapse = '380. Tarmudskud',
  MovementProblems = '700. Bevægelsesproblemer',
  HoofDisorder = '720. Klovlidelse',
  TailBiting = '731. Halebid',
  EarBiting = '732. Ørebid',
  BrainNerveDisorder = '800. Hjerne-/nervelidelse',
  Other = '900. Andet',
  PoorWelfare = '940. Utrivelig',
  Hernia = '950. Brok',
}
